import {
  RECEIVE_SIGN_OUT_USER,
  RECEIVE_AUTHENTICATED_USER
} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

export default function currentUser(state = initialState.currentUser, action) {
  switch (action.type) {
    case RECEIVE_AUTHENTICATED_USER:
      return objectAssign({}, state, {
        uid: action.user.uid,
        name: action.user.displayName,
        email: action.user.email,
        avatarUrl: action.user.photoURL
      });
    case RECEIVE_SIGN_OUT_USER:
      return objectAssign({}, state, initialState.currentUser);
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/currentUser.js
 **/